export const NOT_FOUND_ERROR_MESSAGE = "Gift card could not be found. (404)";
export const PRIMARY_BUTTON_TEXT = "Copy Gift Card ID";
export const PRIMARY_LABEL = "Gift Card ID Number";
export const PRIMARY_MESSAGE =
  "Copy this gift card ID number and paste into the {restaurant} app to add value to your account. Your next purchase will automatically include your new gift card!";
export const PRIMARY_TEXT = "Someone Sent You a Gift Card!";
export const PRIMARY_VALUE_TEXT = "Gift Card Value:";
export const SECONDARY_FROM_INPUT_LABEL = "From";
export const SECONDARY_MESSAGE =
  "Don't have an account? \nDownload the App and Sign Up Now!";
export const SECONDARY_MESSAGE_INPUT_LABEL = "Message";
export const SECONDARY_TEXT = "Gift Card Details";
export const SECONDARY_TO_INPUT_LABEL = "To";
export const UNKNOWN_ERROR_MESSAGE =
  "An unknown error occurred. Please try again or contact the restaurant for help.";

export default {
  NOT_FOUND_ERROR_MESSAGE,
  PRIMARY_BUTTON_TEXT,
  PRIMARY_LABEL,
  PRIMARY_MESSAGE,
  PRIMARY_TEXT,
  PRIMARY_VALUE_TEXT,
  SECONDARY_FROM_INPUT_LABEL,
  SECONDARY_MESSAGE,
  SECONDARY_MESSAGE_INPUT_LABEL,
  SECONDARY_TEXT,
  SECONDARY_TO_INPUT_LABEL,
  UNKNOWN_ERROR_MESSAGE,
};
